import { Redirect, Router } from "@reach/router";
import { User } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import { RouteGuard, getDefaultLink } from "./utils/helpers/role-helpers";
import SuperAgent from "./pages/super-agent";
import AppService from "./pages/app-service";
import MapAcquirer from "./pages/map-Acquirer";

const getRoutes: (user: User | null) => JSX.Element = user => {
  const defaultLink = getDefaultLink(user);

  return (
    <Router>
      {user && <Redirect from="/" to={defaultLink} noThrow />}
      <Redirect from="/spa/batch-credit-ui-portlet" to={defaultLink} noThrow />

      <NotFound default />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["BCP_ADMIN"]}
        component={AppService}
        path="/app-service"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["BCP_ADMIN"]}
        component={SuperAgent}
        path="/super-agent"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["BCP_ADMIN"]}
        component={MapAcquirer}
        path="/map-acquirer"
      />
    </Router>
  );
};

export default getRoutes;
